var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashIconRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.12941H2.55556M2.55556 4.12941H15M2.55556 4.12941V15.0824C2.55556 15.4973 2.71944 15.8953 3.01117 16.1888C3.30289 16.4822 3.69855 16.6471 4.11111 16.6471H11.8889C12.3014 16.6471 12.6971 16.4822 12.9888 16.1888C13.2806 15.8953 13.4444 15.4973 13.4444 15.0824V4.12941H2.55556ZM4.88889 4.12941V2.56471C4.88889 2.14972 5.05278 1.75173 5.3445 1.45829C5.63622 1.16485 6.03189 1 6.44444 1H9.55556C9.96811 1 10.3638 1.16485 10.6555 1.45829C10.9472 1.75173 11.1111 2.14972 11.1111 2.56471V4.12941M6.44444 8.04118V12.7353M9.55556 8.04118V12.7353",
    stroke: "#FF303C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconRed);
export default __webpack_public_path__ + "static/media/trashIcon-red.2169e64c31445ca8bd0a4dff4e458493.svg";
export { ForwardRef as ReactComponent };